import React from "react";
import styles from "./LineWithText.module.css";

interface LineWithTextProps {
  text: string;
}

const LineWithText: React.FC<LineWithTextProps> = ({ text }) => {
  return (
    <div className={styles.container}>
      <div className={styles.line}></div>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default LineWithText;
